export default "__VITE_PUBLIC_ASSET__54925e1f__"